import { z } from 'zod';

export const createSpaceSchema = z.object({
  name: z
    .string()
    .min(2, 'validation.space_name_min_length')
    .max(100, 'validation.space_name_max_length'),
  description: z
    .string()
    .min(10, 'validation.description_min_length')
    .max(500, 'validation.description_max_length'),
  visibility: z.enum(['public', 'private'], {
    required_error: 'validation.visibility_required',
  }),
  ownerId: z.string().uuid('validation.owner_required'),
  joinRule: z.string().optional(),
  requireVerification: z.boolean().optional(),
  verificationUrl: z
    .string()
    .url('validation.url_invalid')
    .optional()
    .or(z.literal('')),
  categoryId: z.string().optional(),
  rules: z.string().optional(),
});

export const updateSpaceSchema = createSpaceSchema
  .omit({ ownerId: true })
  .partial()
  .extend({
    name: z
      .string()
      .min(2, 'validation.space_name_min_length')
      .max(100, 'validation.space_name_max_length'),
  });

export type ICreateSpaceFormData = z.infer<typeof createSpaceSchema>;
export type IUpdateSpaceFormData = z.infer<typeof updateSpaceSchema>;
